require('./bootstrap');

window.Vue = require('vue')

import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios';
import AxiosPlugin from 'vue-axios-cors'
import Skeleton from 'vue-loading-skeleton'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './components/MainComponent.vue'
import VuePNotify from 'vue-pnotify'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueBodyClass from 'vue-body-class';
import loading from 'vuejs-loading-screen'

Vue.use(AxiosPlugin)
Vue.use(VueRouter)
Vue.use(VueSweetalert2)
Vue.use(VueAxios, axios)
Vue.use(Skeleton)
Vue.use(Vuex)
Vue.use(require('vue-moment'));
Vue.use(VuePNotify)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(loading)

window.moment = require('moment');

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm')
    }
})

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
    }
})

Vue.filter('formatTime', function (value) {
    if (value) {
        return moment(String(value)).format('hh:mm')
    }
})

Vue.filter('formatDateTextMonth', function (value) {
    if (value) {
        let month = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember'
        ]
        let month_name = new Date(value).getMonth()
        return moment(String(value)).format('DD ') + month[month_name] + moment(String(value)).format(' YYYY')
    }
})

Vue.mixin({
    methods: {
        inArray(search, array) {
            let exist = false
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element == search) {
                    exist = true
                }
            }
            return exist
        },
        inObject(search, object) {
            let exist = false
            let array = Object.values(object)
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element == search) {
                    exist = true
                }
            }
            return exist
        }
    }
})

import Home from './components/web-service-antrean/Home'
import UpdateWaktuAntrean from './components/web-service-antrean/UpdateWaktuAntrean'
import JadwalOperasi from './components/web-service-antrean/JadwalOperasi'
import UpdateRuangan from './components/web-service-antrean/UpdateRuangan'

const routes = [
    {
        name: 'home',
        path: '/',
        component: Home,
    },
    {
        name: 'update-waktu-antrean',
        path: '/update-waktu-antrean',
        component: UpdateWaktuAntrean,
    },
    {
        name: 'jadwal-operasi',
        path: '/jadwal-operasi',
        component: JadwalOperasi,
    },
    {
        name: 'update-ruangan',
        path: '/update-ruangan',
        component: UpdateRuangan
    },
]

const router = new VueRouter({
    mode: 'history',
    routes: routes,
    linkActiveClass: 'active'
})

const vueBodyClass = new VueBodyClass(routes);
router.beforeEach((to, from, next) => { vueBodyClass.guard(to, next) });

const store = new Vuex.Store({
    state: {
        //
    },
    created() {
        //
    },
    mutations: {
        loadApp() {
            const app = new Vue(Vue.util.extend({ store, router }, App)).$mount('#app')
        },
    }
})

store.commit('loadApp')
